// components/QuantityTableFragments/LocationNotesFragment.js
import React from 'react';
import { Card } from 'reactstrap';
import {
  Editor,
  EditorProvider,
  Toolbar,
  BtnBold,
  BtnItalic,
  BtnBulletList,
  BtnClearFormatting,
  BtnLink,
  BtnNumberedList,
  BtnRedo,
  BtnStrikeThrough,
  BtnStyles,
  BtnUnderline,
  BtnUndo,
  HtmlButton,
  Separator,
} from 'react-simple-wysiwyg';
import { FormField, FormSection } from '../../../Components/Form';

const DeliveryVesselFirstLocationNotes = ({
  deliveryincotermformData,
  handleDeliveryTextChangeIncoterm,
}) => {
  return (
    <FormSection
      title={deliveryincotermformData.incotermLocation2Name || 'Port'}
      description='Notes for this port'
      columns={1}
    >
      <FormField id='loc1NotesForSTS' name='loc1NotesForSTS' label='Notes'>
        <Card className='mb-0'>
          <div className='snow-editor'>
            <EditorProvider>
              <Editor
                id='loc1NotesForSTS'
                name='loc1NotesForSTS'
                value={deliveryincotermformData.loc1NotesForSTS || ''}
                onChange={handleDeliveryTextChangeIncoterm('loc1NotesForSTS')}
                style={{ height: '150px', overflowY: 'auto' }}
              >
                <Toolbar>
                  <BtnBold />
                  <BtnItalic />
                  <BtnBulletList />
                  <BtnClearFormatting />
                  <BtnLink />
                  <BtnNumberedList />
                  <BtnRedo />
                  <BtnStrikeThrough />
                  <BtnStyles />
                  <BtnUnderline />
                  <BtnUndo />
                  <HtmlButton />
                  <Separator />
                </Toolbar>
              </Editor>
            </EditorProvider>
          </div>
        </Card>
      </FormField>
    </FormSection>
  );
};

export default DeliveryVesselFirstLocationNotes;
